import {useReducer} from 'react';

export function useForceUpdate(): () => void {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_ignored, forceUpdate] = useReducer((x) => x + 1, 0);
  return forceUpdate;
}
